var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "26px",
    viewBox: "0 0 32 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header-2-copy-7",
    transform: "translate(-44.000000, -61.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B.",
    transform: "translate(44.448000, 61.800000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.348,25.2 C15.324,25.2 17.61,24.528 19.206,23.184 C20.802,21.84 21.6,19.956 21.6,17.532 C21.6,16.284 21.264,15.162 20.592,14.166 C19.92,13.17 19.092,12.456 18.108,12.024 C18.852,11.64 19.53,11.028 20.142,10.188 C20.754,9.348 21.06,8.352 21.06,7.2 C21.06,4.896 20.316,3.12 18.828,1.872 C17.34,0.624 15.072,7.10542736e-15 12.024,7.10542736e-15 L12.024,7.10542736e-15 L0.9,7.10542736e-15 C0.636,7.10542736e-15 0.42,0.09 0.252,0.27 C0.084,0.45 6.75015599e-14,0.672 6.75015599e-14,0.936 L6.75015599e-14,0.936 L6.75015599e-14,24.3 C6.75015599e-14,24.54 0.09,24.75 0.27,24.93 C0.45,25.11 0.66,25.2 0.9,25.2 L0.9,25.2 L12.348,25.2 Z M11.268,9.972 L6.768,9.972 L6.768,4.86 L11.268,4.86 C12.18,4.86 12.87,5.094 13.338,5.562 C13.806,6.03 14.04,6.636 14.04,7.38 C14.04,8.148 13.8,8.772 13.32,9.252 C12.84,9.732 12.156,9.972 11.268,9.972 L11.268,9.972 Z M11.592,20.34 L6.768,20.34 L6.768,14.688 L11.592,14.688 C12.504,14.688 13.224,14.958 13.752,15.498 C14.28,16.038 14.544,16.716 14.544,17.532 C14.544,18.324 14.286,18.99 13.77,19.53 C13.254,20.07 12.528,20.34 11.592,20.34 L11.592,20.34 Z",
    id: "B",
    fill: "#282642"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.42,25.2 C30.684,25.2 30.9,25.11 31.068,24.93 C31.236,24.75 31.32,24.54 31.32,24.3 L31.32,24.3 L31.32,19.548 C31.32,19.284 31.236,19.062 31.068,18.882 C30.9,18.702 30.684,18.612 30.42,18.612 L30.42,18.612 L25.668,18.612 C25.404,18.612 25.182,18.702 25.002,18.882 C24.822,19.062 24.732,19.284 24.732,19.548 L24.732,19.548 L24.732,24.3 C24.732,24.564 24.822,24.78 25.002,24.948 C25.182,25.116 25.404,25.2 25.668,25.2 L25.668,25.2 L30.42,25.2 Z",
    id: ".",
    fill: "#FF4C60"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8c2fb23675dc34b2041044d6dd41e4e3.svg";
export { ForwardRef as ReactComponent };